import { render, staticRenderFns } from "./canceled.vue?vue&type=template&id=604aa962&scoped=true&"
import script from "./canceled.vue?vue&type=script&lang=js&"
export * from "./canceled.vue?vue&type=script&lang=js&"
import style0 from "./canceled.vue?vue&type=style&index=0&id=604aa962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604aa962",
  null
  
)

export default component.exports